//options for stripe payment request button
import { useMemo } from 'react';
import { SavedCreditCardsType } from '../type';
import { IntlShape } from 'react-intl';

export const confirmPaymentMethodErrors = (intl: IntlShape) => ({
  payment_intent_authentication_failure: intl.formatMessage({
    id: 'booking.payment.error',
    defaultMessage: 'Ви не пройшли 3D верифікацію. Спробуйте ще раз.',
  }),
});

export const useOptions = () => {
  const options = useMemo(
    () => ({
      hidePostalCode: true,
      style: {
        base: {
          color: '#1D201F',
          letterSpacing: '0.025em',
          fontFamily: 'Inter, sans-serif',
          '::placeholder': {
            color: '#C1C1C1',
          },
          fontSize: '12px',
        },
        invalid: {
          color: '#9e2146',
        },
      },
    }),
    []
  );

  return options;
};

export const sortCardsByDefaultPaymentMethod = (cards: Array<SavedCreditCardsType>) => {
  const cardsCopy = [...cards];
  return cardsCopy.sort((cardA, cardB) =>
    cardA.isDefaultPaymentMethod === cardB.isDefaultPaymentMethod ? 0 : cardA.isDefaultPaymentMethod ? -1 : 1
  );
};
